export function getDomainName(url = window.location.href) {
  // from a.b.c.test.io => test.io
  const urlObject = new URL(url);
  const hostnameArray = urlObject.hostname.split(".");
  const numberOfSubdomains = hostnameArray.length - 2;
  return hostnameArray.length === 2
    ? urlObject.hostname
    : hostnameArray.slice(numberOfSubdomains).join(".");
}
